import { Outlet, useOutletContext } from 'react-router-dom'
import { BreadcrumbItem } from '@/components/ui/breadcrumb-nav'
import { useSoftwareContext } from '../SoftwarePage'

type OutletContextType = {
  parentBreadcrumbs: BreadcrumbItem[]
}

export function VerticalSolutionsPage() {
  // Get the breadcrumbs from SoftwarePage
  const { parentBreadcrumbs } = useSoftwareContext()

  // Build vertical solutions breadcrumbs
  const breadcrumbs: BreadcrumbItem[] = [
    ...parentBreadcrumbs,
    {
      label: "Verticals & Standalone Solutions",
      description: "Industry-specific software solutions designed for specialized needs",
      href: "/software/vertical"
    }
  ]

  return (
    <Outlet context={{ parentBreadcrumbs: breadcrumbs }} />
  )
}

export function useVerticalSolutionsContext() {
  return useOutletContext<OutletContextType>()
}